import { Nav } from "reactstrap"

export default Nav
